import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { AltOfferingsEnvironment } from './environment';
import { IngressAltOffering, IngressAltOfferingCompany, PaginatedIngressAltOffering } from './ingress';
import { FilterOptions } from './store';
import { OfferingFeedback, OfferingFeedbackResponse } from './entities';

export class AltOfferingsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(AltOfferingsEnvironment).url, session);
  }

  getOfferings = (params?: any): SafePromise<{ data: IngressAltOffering[] }> => {
    const url = this.URL(`offerings`, params);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getReviews = (params?: FilterOptions): SafePromise<{ data: PaginatedIngressAltOffering }> => {
    const url = this.URL(`reviews`, params);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getListing = (listingSlug: string): SafePromise<{ data: IngressAltOffering }> => {
    const url = this.URL(`offerings/${listingSlug}`);
    console.log('get listing: ', url);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  submitOfferFeedback = (
    listingSlug: number | string,
    offeringFeedback: OfferingFeedback,
  ): SafePromise<OfferingFeedbackResponse> => {
    const url = this.URL(`offerings/${listingSlug}/feedback`);
    // console.log('submit offer feedback: ', url, offeringFeedback);
    return this.post(url, offeringFeedback, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getCompany = (companySlug: string): SafePromise<IngressAltOfferingCompany> => {
    const url = this.URL(`alternate-investments/company/${companySlug}`);
    console.log('get company: ', url);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
